import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-migration-tool',
  templateUrl: './cloud-migration-tool.component.html',
  styleUrls: ['./cloud-migration-tool.component.scss']
})
export class CloudMigrationToolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
